module.exports = __webpack_public_path__ + "static/img/lxm.0449bdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/doctor/lxm.jpg
// module id = G5EJ
// module chunks = 1